export enum ELogEntryInputSignificance {
	None,
	Routine,
	Important,
	Monumental
}
